import styled from '@emotion/styled'
import theme from '../constants/theme'

const Section = styled('div')`
  padding-bottom: ${theme.margin.mid};
`

export default Section